import styled from 'styled-components';
import space from '../utils/style/space';

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: ${space.xl}px;
`;

export default ButtonContainer;
